export const TRAVEL_TYPE_PACKAGE_TOUR = 'packageTour';
export const TRAVEL_TYPE_OWN_ARRIVAL = 'ownArrival';
export const TRAVEL_TYPE_HOLIDAY_HOMES = 'holidayHomes';
export const INVIA_TYPE_CAN_INCLUDED = 'IT08F-CAN#FEE#FEIN';
export const INVIA_TYPE_CAN_EXCLUDED = 'IT08F-CAN#FEE#FEE';
export const INVIA_TYPE_RES_INCLUDED = 'IT08F-RES#INC';
export const INVIA_TYPE_RES_EXCLUDED = 'IT08F-RES#EXC';
export const INSURANCE = 'insurance';
export const SUSTAINABILITY = 'sustainability';
export const COVIDINSURANCE = 'covidInsurance';